/// <amd-module name="SuiteCommerce.Blog.Common.ParameterProcessor"/>
define("SuiteCommerce.Blog.Common.ParameterProcessor", ["require", "exports", "SuiteCommerce.Blog.Common"], function (require, exports, Common_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ParameterProcessor = exports.SearchPhraseSettings = exports.PageSettings = void 0;
    var PageSettings;
    (function (PageSettings) {
        PageSettings["page"] = "page";
    })(PageSettings = exports.PageSettings || (exports.PageSettings = {}));
    var SearchPhraseSettings;
    (function (SearchPhraseSettings) {
        SearchPhraseSettings["keywords"] = "keywords";
    })(SearchPhraseSettings = exports.SearchPhraseSettings || (exports.SearchPhraseSettings = {}));
    var ParameterProcessor = /** @class */ (function () {
        function ParameterProcessor() {
        }
        ParameterProcessor.getProcessedNavigationData = function (urlFragment) {
            var urlComponents = this.decodeParams(urlFragment);
            if (urlComponents) {
                return this.getNavigationData(urlComponents);
            }
            return;
        };
        ParameterProcessor.decodeParams = function (urlFragment) {
            try {
                var components = {};
                var componentURLDecoded = decodeURIComponent(urlFragment);
                if (componentURLDecoded.split('?').length > 0) {
                    var fragments = componentURLDecoded.split('?');
                    var params = fragments.shift();
                    var paramsArray = params.split('/');
                    paramsArray.shift();
                    components.params = paramsArray.join('/');
                    components.queryParams = fragments.join('?');
                }
                return components;
            }
            catch (exception) {
                console.warn('Search canceled: URI malformed', exception);
                return {};
            }
        };
        ParameterProcessor.getNavigationData = function (components) {
            var _this = this;
            var data = {};
            if (components.params) {
                var taxonomyComponents = components.params.split('/');
                data.mainTaxonomy = {
                    name: taxonomyComponents[0],
                    value: taxonomyComponents[1],
                };
                data.taxonomies = [data.mainTaxonomy];
            }
            if (components.queryParams) {
                components.queryParams.split('&').forEach(function (paramAndValue) {
                    var pieces = paramAndValue.split('=');
                    var paramName = pieces.shift();
                    var value = pieces.join('=');
                    if (paramName in PageSettings && paramName === PageSettings.page) {
                        if (!isNaN(parseInt(value, 10))) {
                            data.pageNumber = parseInt(value, 10);
                        }
                    }
                    // Additional taxonomies in query params only are taking into consideration
                    // if the user is visiting a taxonomy page (taxonomy existing in parameters)
                    if (data.mainTaxonomy && _this.isWhitelistedTaxonomy(paramName)) {
                        if (!data.taxonomies)
                            data.taxonomies = [];
                        if (value !== data.mainTaxonomy.value) {
                            data.taxonomies.push({
                                value: value,
                                name: paramName,
                            });
                        }
                    }
                    if (paramName in SearchPhraseSettings &&
                        paramName === SearchPhraseSettings.keywords) {
                        data.searchPhrase = value;
                    }
                });
            }
            if (Object.keys(data).length !== 0)
                return data;
            return;
        };
        ParameterProcessor.isWhitelistedTaxonomy = function (param) {
            return param in Common_1.AvailableTaxonomies;
        };
        return ParameterProcessor;
    }());
    exports.ParameterProcessor = ParameterProcessor;
});
